import { useEffect, useState } from 'react';
import { getLocalStorageState, setLocalStorageState } from 'utils/local-storage';

export const useToggleLocalStorage = ({ name = 'agentspace', defaultValue = false }) => {
  if (!name) {
    throw new Error('useToggleLocalStorage must have "name" param');
  }

  const [toggleValue, setToggleValue] = useState(() => {
    const initialValue = getLocalStorageState(name);
    return initialValue === 'true' ? true : initialValue === 'false' ? false : defaultValue;
  });

  useEffect(() => {
    const initialValue = getLocalStorageState(name);
    setToggleValue(initialValue === 'true' ? true : initialValue === 'false' ? false : defaultValue);
  }, [name, defaultValue]);

  const toggle = () => {
    const newValue = !toggleValue;
    setToggleValue(newValue);
    setLocalStorageState(name, newValue.toString());
  };

  return {
    toggleValue,
    toggle,
  };
};
